<template>
    <div class="footer-bottom">
        <div class="site-info">
            <p>Copyright@{{$config.title}}</p>
            <!-- <p v-if="siteInfo.web_phone"><i class="iconfont icondianhua"></i>{{ siteInfo.web_phone }}</p> -->
            <p v-if="siteInfo.web_email">
                <i class="iconfont iconyouxiang"></i>
                <el-link :href="`mailto:${siteInfo.web_email}`">{{ siteInfo.web_email }}</el-link>
            </p>
            <p>
                {{ copyRight.copyright_desc }}
                
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" class="footer-link new-link">
                    <img src="@/assets/images/guohui.png" />鲁公网安备 37021402001303号
                </a>
                <a v-if="copyRight.icp" class="footer-link" href="http://beian.miit.gov.cn" target="_blank">备案号：{{ copyRight.icp }}</a>
            </p>
            
        </div>
        <!-- <div class="record">
			
		</div> -->
    </div>
</template>

<script>
import { copyRight } from "@/api/website"
import { mapGetters } from "vuex"
export default {
    props: {},
    data() {
        return {}
    },
    computed: {},
    created() {
        this.$store.dispatch("site/copyRight")
    },
    mounted() {},
    watch: {},
    methods: {},
    computed: {
        ...mapGetters(["copyRight", "siteInfo"])
    }
}
</script>

<style scoped lang="scss">
.footer-bottom {
    // width: 100%;
    // height: 80px;
    padding: 20px 0;
    // display: flex;
    width: 1210px;
    margin: 0 auto;

    p {
        margin: 0;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }
        .footer-link,
        .el-link.el-link--default {
            color: #9d9d9d;
        }
        .footer-link:hover,
        .el-link.el-link--default:hover {
            color: $base-color;
        }
    }
    .site-info {
        display: flex;
        justify-content: center;
        align-items: center;
        // width: 400px;
        p {
            width: auto;
            margin: 0 10px;

            i {
                vertical-align: bottom;
                margin-right: 5px;
            }
        }
        * {
            line-height: 40px;
        }
    }
    .record {
        // display: flex;
        flex: 1;
        width: 810px;
        p {
            width: auto;
            margin: 0 10px;
            float: right;
            line-height: 40px;
        }
    }
    .new-link {
        margin: 0 15px;
    }
}
</style>
